module.exports = __webpack_public_path__ + "static/media/4.69e729e5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/4.mp3
// module id = 55
// module chunks = 0